'use client'

import { ChakraProvider } from '@chakra-ui/react'
import { ColorModeProvider } from './color-mode'
import { Toaster } from './toaster'
import { system } from '../../theme'

export function Provider(props) {
  const { children, ...rest } = props
  return (
    <ChakraProvider value={system}>
      <ColorModeProvider {...rest}>
        {children}
        <Toaster />
      </ColorModeProvider>
    </ChakraProvider>
  )
}
